module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27617",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4170",
      "atom": "static-1.4670",
      "conversations-async-data": "static-2.7243",
      "conversations-error-reporting": "static-1.8471",
      "conversations-infrastructure": "static-1.8493",
      "conversations-internal-pub-sub": "static-1.15546",
      "conversations-internal-schema": "static-1.12206",
      "conversations-message-history": "static-1.11297",
      "conversations-test-sdk": "static-1.9989",
      "conversations-visitor-experience-components": "static-1.20980",
      "head-dlb": "static-1.4465",
      "hs-promise-utils": "static-1.5070",
      "hs-test-utils": "static-1.7486",
      "hubspot-dlb": "static-2.1739",
      "HubStyleTokens": "static-2.11010",
      "I18n": "static-7.1493",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.2507",
      "jasmine-runner": "static-1.5958",
      "quartz": "static-1.6344",
      "react-dlb": "static-1.65",
      "react-select-plus": "static-1.65",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.3947",
      "StyleGuideUI": "static-3.479",
      "transmute": "static-2.77",
      "urlinator": "static-1.4108",
      "usage-tracker": "static-1.6916",
      "usage-tracker-core": "static-1.6766",
      "usage-tracker-public": "static-1.6727",
      "viral-links-lib": "static-1.6498",
      "visitor-ui-component-library": "static-1.5707",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4318",
      "conversations-prop-types": "static-1.6919",
      "conversations-visibility-tools": "static-1.5281",
      "conversations-visitor-message-history": "static-1.19717",
      "cssUtils": "static-1.645",
      "enviro": "static-4.345",
      "flux-actions": "static-1.291",
      "foundations-components": "static-1.7079",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3757",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9220",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.319",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.16207",
      "react-utils": "static-2.4934",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7694",
      "signup-constants": "static-1.17902",
      "styled-components": "static-2.64",
      "usage-tracker-multi": "static-1.5330",
      "visitor-ui-component-library-icons": "static-1.5518",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3029",
      "moment": "static-3.26",
      "quartz-config": "static-1.122",
      "quartz-core": "static-1.5563",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4367",
      "foundations-theming": "static-1.3907",
      "UIComponents": "static-3.7957",
      "cv-backend-services": "static-1.1397",
      "immutable-less": "static-1.4098",
      "conversations-skeleton-state": "static-1.6844",
      "crm-events-viz-core": "static-1.31788",
      "customer-agent-discovery-components-lib": "static-1.1830",
      "icons": "static-2.599",
      "react-input-autosize": "static-2.17",
      "react-router-dom": "static-5.26",
      "rpc-client-utils": "static-1.4196",
      "tanstack-virtual": "static-1.20",
      "ui-images": "static-2.1006",
      "HeadJS": "static-2.652",
      "framer-motion": "static-1.58",
      "hs-test-utils-bend-plugin": "static-1.2597",
      "msw": "static-1.39",
      "testing-library": "static-1.140",
      "i18n-data": "static-1.212",
      "moment-timezone": "static-5.73",
      "jasmine": "static-4.3815",
      "signup-ui-url-generator": "static-2.7593",
      "HubStyle": "static-2.11318",
      "sassPrefix": "static-1.146",
      "bend-plugin-foundations-components": "static-1.3348",
      "floating-ui": "static-1.46",
      "foundations-theming-specialty": "static-1.1623",
      "hs-story-utils": "static-1.8906",
      "react-virtualized": "static-2.87",
      "tanstack-table": "static-1.23",
      "trellis-assets": "static-1.781",
      "ui-fonts": "static-1.335",
      "csstype": "static-1.50",
      "quick-fetch": "static-1.3524",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5333",
      "bender-build-tools": "static-1.2674",
      "dispatcher": "static-1.126",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.730",
      "hub-http-shared-msw-handlers": "static-1.8912",
      "hubspotter-http": "static-1.4228",
      "hubspotter-http-shared-msw-handlers": "static-1.8910",
      "mobile-manifest-mixins": "static-1.425",
      "quartz-auth": "static-1.19",
      "quartz-head": "static-1.9",
      "quartz-i18n": "static-1.19",
      "bend-plugin-foundations-theming": "static-1.2390",
      "foundations-theming-base": "static-1.2892",
      "stylex": "static-1.22",
      "ts-schema": "static-1.3701",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.2044",
      "content-assistance-lib": "static-1.7159",
      "crm-component-utils": "static-1.37902",
      "crm-display-components": "static-1.23652",
      "crm-fe-perf": "static-1.22472",
      "crm-links": "static-1.5733",
      "crm-message-bus": "static-1.41757",
      "crm-search-service-types": "static-1.788",
      "crm-source-interpretation-lib": "static-1.4810",
      "customer-data-communicator": "static-1.44292",
      "customer-data-email": "static-1.17197",
      "customer-data-filters-ui": "static-1.38088",
      "customer-data-objects": "static-1.7186",
      "customer-data-objects-ui-components": "static-1.12536",
      "customer-data-properties": "static-1.50082",
      "customer-data-rte": "static-1.31888",
      "customer-data-ui-utilities": "static-1.9307",
      "data-fetching-client": "static-1.9216",
      "draft-plugins": "static-2.20827",
      "file-manager-components": "static-1.22194",
      "FileManagerCore": "static-1.37693",
      "framework-data-schema-resolvers": "static-1.6446",
      "frontend-preferences-client": "static-1.7497",
      "hubspot-apollo-client": "static-1.4358",
      "hubspot-prosemirror": "static-1.16996",
      "object-comments-thread-lib": "static-1.9539",
      "reference-resolvers-lite": "static-1.7588",
      "ui-addon-upgrades": "static-9.17226",
      "universal-associations-select": "static-1.10521",
      "ai-components-ui-library": "static-1.7704",
      "final-form": "static-1.60",
      "graphql": "static-1.72",
      "superstore": "static-1.4279",
      "ui-addon-video-player": "static-1.8304",
      "ui-coaching-tips": "static-1.27308",
      "card-properties-lib": "static-1.42906",
      "crm-actions": "static-1.5740",
      "crm-cards-data": "static-1.736",
      "crm-cards-sdk": "static-1.42268",
      "customer-data-properties-shared-msw-handlers": "static-1.8239",
      "customer-data-property-utils": "static-1.7534",
      "customer-data-tracking": "static-1.6439",
      "usage-tracker-container": "static-1.6906",
      "framework-data-table": "static-2.10868",
      "location-customization-utils-lib": "static-1.7897",
      "calling-error-reporting": "static-1.30857",
      "calling-internal-common": "static-1.30851",
      "calling-usage-tracker": "static-1.6119",
      "crm_data": "static-4.90498",
      "crm_schema": "static-3.90537",
      "crm-legacy-global-containers": "static-1.23337",
      "customer-data-content": "static-1.26401",
      "draft-content-plugins": "static-1.27259",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.23247",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22956",
      "EmailSignatureEditor": "static-1.23516",
      "FileManagerLib": "static-1.37834",
      "hubspot-prosemirror-plugins": "static-1.16988",
      "integration-settings-components": "static-1.14045",
      "integrations-lib": "static-1.14708",
      "integrations-tracking-lib": "static-1.5168",
      "native-integrations-shared-strings": "static-1.7366",
      "nav-meta": "static-1.28309",
      "onboarding-scopes": "static-1.6025",
      "outreach-assistant-email-generation": "static-1.5340",
      "property-translator": "static-1.4907",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.36487",
      "react-colorpicker": "static-2.9764",
      "react-dnd-compat": "static-1.4206",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7748",
      "rich-text-lib": "static-1.18990",
      "sales-email-signature-service-client": "static-1.3428",
      "sequences-lib": "static-1.7335",
      "timezone-utils": "static-2.4732",
      "ui-addon-i18n": "static-1.10581",
      "ui-addon-iframeable": "static-1.8481",
      "ui-business-units-lib": "static-1.8489",
      "ui-gdpr-components": "static-1.9803",
      "ui-shepherd-react": "static-3.9632",
      "user-context": "static-1.4669",
      "whatsapp-sending-lib": "static-1.4328",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4233",
      "salesImages": "static-1.515",
      "customer-data-filters-ui-msw-helpers": "static-1.20522",
      "customer-data-reference-ui-components": "static-1.12602",
      "FormUrlGenerator": "static-2.4211",
      "framework-builder-read-service-client": "static-1.3563",
      "framework-data-schema-quick-fetch": "static-1.6351",
      "inbound-db-meta-service-client": "static-1.3255",
      "inbound-db-properties-service-client": "static-1.3487",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.547",
      "onboarding-tours": "static-1.15959",
      "reporting-datasets-permissions-lib": "static-1.12329",
      "SharedI18nStrings": "static-1.177",
      "ui-addon-teams": "static-1.20927",
      "calling-global-api": "static-1.62963",
      "calling-lifecycle-internal": "static-1.64345",
      "calling-lifecycle-messages": "static-1.56639",
      "commerce-products-lib": "static-1.8139",
      "conditional-properties-service-client": "static-1.3428",
      "external-options-client-types": "static-1.3647",
      "google-libphonenumber": "static-1.27",
      "inbound-db-associations-writes-service-client": "static-1.2754",
      "inbounddb-objects-service-types": "static-1.3735",
      "meetings-icalendar-utils-lib": "static-1.117",
      "multi-currency-client-types": "static-1.3265",
      "object-builder-ui-client": "static-1.47250",
      "pipeline-validation-client-types": "static-1.3488",
      "property-value-citations": "static-1.696",
      "smart-property-lib": "static-1.5045",
      "tiered-pricing": "static-1.481",
      "ui-addon-form-validation": "static-1.10540",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3638",
      "video-components-external": "static-1.9917",
      "video-data-lib": "static-1.33575",
      "audio-components": "static-1.5326",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.35345",
      "video-components": "static-1.11920",
      "video-embed": "static-1.34409",
      "batch-promise": "static-1.1123",
      "crm-pipelines-api-client-types": "static-1.3626",
      "persist-promise": "static-1.3280",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.24076",
      "knowledge-content-types": "static-1.8170",
      "payment-link-components": "static-1.22360",
      "ui-addon-emoji-picker": "static-1.9435",
      "call-summary": "static-1.37654",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.9058",
      "feature-store-service-types": "static-1.4126",
      "growth-monetization-service-types": "static-1.4133",
      "merchandise-lib": "static-1.248",
      "purchase-motions-components": "static-1.5074",
      "self-service-api": "static-1.9757",
      "upgrade-management-service-types": "static-1.4117",
      "chatspot-client-types": "static-1.10229",
      "chatspot-core": "static-1.19508",
      "ContentUtils": "static-1.66979",
      "copilot-toolkit": "static-1.9897",
      "growth-onboarding-feedback-components": "static-1.6073",
      "customer-data-sidebar": "static-2.44762",
      "enrichment-properties-lib": "static-1.14163",
      "customer-data-associations": "static-1.6807",
      "deal-intel-decorators": "static-1.562",
      "reporting-data": "static-1.65619",
      "ui-addon-draggable": "static-3.4341",
      "crm-record-cards-service-types": "static-1.3264",
      "crm_universal": "static-1.21357",
      "SalesContentIndexUI": "static-3.8465",
      "signup-ui-lego-core": "static-1.19912",
      "content-embed-lib": "static-1.6922",
      "data-model-builder-lib": "static-1.10839",
      "remote-ui": "static-1.55",
      "ui-components-test-utils": "static-1.5148",
      "ui-extensions-remote-renderer": "static-1.15868",
      "universal-page-editor-lib": "static-1.2569",
      "integrations-error-boundary-lib": "static-1.12123",
      "laboratory-lib": "static-3.6676",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9965",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8399",
      "messaging-types-lib": "static-1.44671",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15662",
      "sequences-client-types-lib": "static-1.7192",
      "foundations-components-test-utils": "static-1.4563",
      "magpie-lib": "static-1.5146",
      "navigation-messaging": "static-1.5999",
      "getting-started-shared-tasks": "static-1.17258",
      "getting-started-shared-tasks-store": "static-1.16376",
      "whatsapp-management-lib": "static-1.7487",
      "growth-data-modal": "static-1.4895",
      "growth-onboarding-confetti": "static-1.2591",
      "growth-onboarding-next-action-utils": "static-1.969",
      "navigation-components": "static-1.16672",
      "onboarding-tours-client": "static-1.4173",
      "onboarding-tours-utils": "static-1.25",
      "ui-shepherd-tracker": "static-1.7013",
      "shared-worker-versioning": "static-1.10599",
      "calling-orchestration-shared-library": "static-1.34144",
      "products-iframe-lib": "static-1.6718",
      "products-ui-components-shared-msw-handlers": "static-1.9294",
      "breeze-intelligence-kit": "static-1.4989",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8995",
      "fsm": "static-1.3224",
      "policy-lib": "static-1.6311",
      "react-tinymce": "static-1.53981",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.53107",
      "tinymce-plugins": "static-1.56221",
      "tinymce-themes": "static-1.55077",
      "content-media-composition-data-lib": "static-1.10403",
      "content-media-compositions": "static-2.14410",
      "idb-keyval": "static-1.34",
      "magpie-types": "static-1.4606",
      "media-bridge-lib": "static-1.18197",
      "content-icons-ui": "static-1.2060",
      "social-insights-client-types": "static-1.20801",
      "outpost": "static-1.3822",
      "commerce-analytics-service-client": "static-1.3182",
      "ui-addon-opt": "static-4.7978",
      "commerce-tours-lib": "static-1.5354",
      "growth-onboarding-reliability": "static-1.4672",
      "sales-checkout-service-client": "static-1.3194",
      "ai-addon-copilot-preview": "static-1.6916",
      "calling-cross-tab-library": "static-1.18823",
      "calling-lifecycle-usage-tracker": "static-1.7524",
      "wootric-nps": "static-1.6445",
      "nav-client-types": "static-1.1816",
      "purchase-motions-api": "static-1.5076",
      "trials-service-types": "static-1.3534",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4237",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2539",
      "card-payment-highlight-lib": "static-1.35898",
      "card-subscription-highlight-lib": "static-1.38286",
      "commerce-billing-lib": "static-1.17845",
      "commerce-contract-lib": "static-1.10404",
      "crm_components": "static-3.90498",
      "invoices-highlight-card-lib": "static-1.53320",
      "orders-highlight-card-lib": "static-1.20383",
      "products-highlight-card-lib": "static-1.16423",
      "project-storage": "static-1.4208",
      "quotes-highlight-card-lib": "static-1.70400",
      "usage-based-billing-components-lib": "static-1.7412",
      "deal-intel-utils": "static-1.566",
      "reporting-client-types": "static-1.2304",
      "react-flip-move": "static-1.60",
      "FireAlarmUi": "static-1.4131",
      "sales-templates-service-types-lib": "static-1.3789",
      "ui-asset-management-lib": "static-1.10390",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.9015",
      "collaboration-sidebar": "static-1.56595",
      "conditional-property-settings-modal": "static-1.11440",
      "data-model-commons-lib": "static-1.11375",
      "feedback-loader": "static-1.28367",
      "html-to-image": "static-1.44",
      "object-definition-builder-lib": "static-1.6577",
      "property-management-iframe": "static-1.11510",
      "reactflow": "static-1.51",
      "simple-data-table": "static-1.1524",
      "used-in-list-lib": "static-1.6432",
      "visual-association": "static-1.5362",
      "highcharts": "static-8.94",
      "reporting-visualizations": "static-1.57696",
      "ui-extensibility-client-types": "static-1.3555",
      "automation-platform-service-types": "static-1.2367",
      "ContentData": "static-1.67054",
      "email-portal-health-service-types": "static-1.564",
      "marketing-email-service-types": "static-1.1666",
      "reactive-lib": "static-1.273",
      "content-whatsapp-service-types": "static-1.110",
      "marketing-platform-lib": "static-1.6300",
      "short-messages-app-service-client": "static-1.3592",
      "ui-tool-access": "static-1.9666",
      "calling-orchestration-schema": "static-1.34369",
      "sales-views-client-types": "static-1.3823",
      "trellis-story-utils": "static-1.4064",
      "storybook-react": "static-1.22",
      "hub-http-contrib": "static-1.2642",
      "interframe": "static-3.4286",
      "tinymce-data": "static-1.39192",
      "ui-addon-sales-email": "static-1.4746",
      "codemirror": "static-5.85",
      "layout-dnd-components": "static-1.11616",
      "layout-dnd-utils": "static-1.10591",
      "react-codemirror": "static-1.10186",
      "ui-brand-identity-lib": "static-1.12900",
      "NamespacedHubStyle": "static-2.8710",
      "hls.js": "static-1.29",
      "js-cookie": "static-1.18",
      "ai-rendering-library": "static-1.8630",
      "ai-settings-ui-library": "static-1.6980",
      "chirp-fetch": "static-1.1478",
      "copilot-plugins": "static-1.9870",
      "eligibility-engine-service-types": "static-1.2815",
      "commerce-shared-components-lib": "static-1.17335",
      "commerce-subscription-lib": "static-1.35863",
      "commerce-tools-ui-lib": "static-1.9280",
      "usage-tracker-session-replay": "static-1.4602",
      "utility-belt": "static-1.2026",
      "payments-enrollment-embed-lib": "static-1.21219",
      "quotes-ui-lib": "static-1.79118",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.6270",
      "invoices-ui-lib": "static-1.53336",
      "commerce-products-api": "static-1.1544",
      "SafeStorage": "static-1.3880",
      "invoices-iframe-lib": "static-1.55394",
      "quotes-modal-lib": "static-1.101075",
      "reporting-ui-components": "static-2.62893",
      "subscription-experience-data-types": "static-1.14184",
      "association-translator": "static-1.2687",
      "crm-settings-header-lib": "static-1.7778",
      "settings-ui-nav": "static-2.9729",
      "chatspot-widget-iframe": "static-1.19500",
      "collaboration-sidebar-common": "static-1.1391",
      "crm-properties-common-lib": "static-1.5339",
      "ui-addon-draggable-compat": "static-2.3836",
      "property-management-common": "static-1.3797",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.14433",
      "advanced-menus-lib": "static-1.11448",
      "ExportDialog": "static-6.9975",
      "ui-memberships-settings-lib": "static-1.32770",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8916",
      "browser-eslint": "static-2.57",
      "embedded-academy-lib": "static-1.12897",
      "highlight.js": "static-1.69",
      "reporting-action-components": "static-1.40100",
      "ui-addon-react-router-dom": "static-1.9124",
      "growth-onboarding-empty-states": "static-1.5061",
      "InboxConnectUtils": "static-4.13667",
      "payments-post-enroll-local-storage-lib": "static-1.4569",
      "qrcode-generator": "static-1.59",
      "amplitude-session-replay-browser": "static-1.50",
      "marketplace-ui-apps-core": "static-1.16846",
      "stripe-embedded-components": "static-1.6769",
      "products-ui-components": "static-1.38658",
      "totals-ui-components": "static-1.22368",
      "reporting-plugins": "static-1.9601",
      "reporting-reports": "static-1.65299",
      "reporting-snowflake": "static-1.54239",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14432",
      "simple-menus-lib": "static-1.15949",
      "academy-common-lib": "static-1.12357",
      "dashboard-lib": "static-1.79730",
      "share-with-third-party-component-lib": "static-1.8229",
      "developer-experience-shared-components": "static-1.9949",
      "marketplace-ui-client-types": "static-1.15719",
      "marketplace-ui-common": "static-1.18312",
      "ui-addon-integrations-directory-panel": "static-2.7559",
      "stripe-connect-js": "static-1.43",
      "commerce-permissions": "static-1.279",
      "property-description-translator": "static-1.3354",
      "commerce-totals-service-types": "static-1.3382",
      "campaign-roi-lib": "static-1.7615",
      "academy-service-client": "static-1.3225",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3477",
      "oauth-service-types": "static-1.3789",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27617",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4170",
      "atom": "/atom/static-1.4670",
      "conversations-async-data": "/conversations-async-data/static-2.7243",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8471",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8493",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15546",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12206",
      "conversations-message-history": "/conversations-message-history/static-1.11297",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9989",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20980",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-promise-utils": "/hs-promise-utils/static-1.5070",
      "hs-test-utils": "/hs-test-utils/static-1.7486",
      "hubspot-dlb": "/hubspot-dlb/static-2.1739",
      "HubStyleTokens": "/HubStyleTokens/static-2.11010",
      "I18n": "/I18n/static-7.1493",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.2507",
      "jasmine-runner": "/jasmine-runner/static-1.5958",
      "quartz": "/quartz/static-1.6344",
      "react-dlb": "/react-dlb/static-1.65",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.3947",
      "StyleGuideUI": "/StyleGuideUI/static-3.479",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.4108",
      "usage-tracker": "/usage-tracker/static-1.6916",
      "usage-tracker-core": "/usage-tracker-core/static-1.6766",
      "usage-tracker-public": "/usage-tracker-public/static-1.6727",
      "viral-links-lib": "/viral-links-lib/static-1.6498",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5707",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4318",
      "conversations-prop-types": "/conversations-prop-types/static-1.6919",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5281",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19717",
      "cssUtils": "/cssUtils/static-1.645",
      "enviro": "/enviro/static-4.345",
      "flux-actions": "/flux-actions/static-1.291",
      "foundations-components": "/foundations-components/static-1.7079",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3757",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9220",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.16207",
      "react-utils": "/react-utils/static-2.4934",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7694",
      "signup-constants": "/signup-constants/static-1.17902",
      "styled-components": "/styled-components/static-2.64",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5330",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5518",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3029",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.122",
      "quartz-core": "/quartz-core/static-1.5563",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4367",
      "foundations-theming": "/foundations-theming/static-1.3907",
      "UIComponents": "/UIComponents/static-3.7957",
      "cv-backend-services": "/cv-backend-services/static-1.1397",
      "immutable-less": "/immutable-less/static-1.4098",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6844",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31788",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1830",
      "icons": "/icons/static-2.599",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-router-dom": "/react-router-dom/static-5.26",
      "rpc-client-utils": "/rpc-client-utils/static-1.4196",
      "tanstack-virtual": "/tanstack-virtual/static-1.20",
      "ui-images": "/ui-images/static-2.1006",
      "HeadJS": "/HeadJS/static-2.652",
      "framer-motion": "/framer-motion/static-1.58",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2597",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.140",
      "i18n-data": "/i18n-data/static-1.212",
      "moment-timezone": "/moment-timezone/static-5.73",
      "jasmine": "/jasmine/static-4.3815",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7593",
      "HubStyle": "/HubStyle/static-2.11318",
      "sassPrefix": "/sassPrefix/static-1.146",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3348",
      "floating-ui": "/floating-ui/static-1.46",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1623",
      "hs-story-utils": "/hs-story-utils/static-1.8906",
      "react-virtualized": "/react-virtualized/static-2.87",
      "tanstack-table": "/tanstack-table/static-1.23",
      "trellis-assets": "/trellis-assets/static-1.781",
      "ui-fonts": "/ui-fonts/static-1.335",
      "csstype": "/csstype/static-1.50",
      "quick-fetch": "/quick-fetch/static-1.3524",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5333",
      "bender-build-tools": "/bender-build-tools/static-1.2674",
      "dispatcher": "/dispatcher/static-1.126",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.730",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8912",
      "hubspotter-http": "/hubspotter-http/static-1.4228",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8910",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.425",
      "quartz-auth": "/quartz-auth/static-1.19",
      "quartz-head": "/quartz-head/static-1.9",
      "quartz-i18n": "/quartz-i18n/static-1.19",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2390",
      "foundations-theming-base": "/foundations-theming-base/static-1.2892",
      "stylex": "/stylex/static-1.22",
      "ts-schema": "/ts-schema/static-1.3701",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.2044",
      "content-assistance-lib": "/content-assistance-lib/static-1.7159",
      "crm-component-utils": "/crm-component-utils/static-1.37902",
      "crm-display-components": "/crm-display-components/static-1.23652",
      "crm-fe-perf": "/crm-fe-perf/static-1.22472",
      "crm-links": "/crm-links/static-1.5733",
      "crm-message-bus": "/crm-message-bus/static-1.41757",
      "crm-search-service-types": "/crm-search-service-types/static-1.788",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4810",
      "customer-data-communicator": "/customer-data-communicator/static-1.44292",
      "customer-data-email": "/customer-data-email/static-1.17197",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38088",
      "customer-data-objects": "/customer-data-objects/static-1.7186",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12536",
      "customer-data-properties": "/customer-data-properties/static-1.50082",
      "customer-data-rte": "/customer-data-rte/static-1.31888",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9307",
      "data-fetching-client": "/data-fetching-client/static-1.9216",
      "draft-plugins": "/draft-plugins/static-2.20827",
      "file-manager-components": "/file-manager-components/static-1.22194",
      "FileManagerCore": "/FileManagerCore/static-1.37693",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6446",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7497",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4358",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16996",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9539",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7588",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17226",
      "universal-associations-select": "/universal-associations-select/static-1.10521",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7704",
      "final-form": "/final-form/static-1.60",
      "graphql": "/graphql/static-1.72",
      "superstore": "/superstore/static-1.4279",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8304",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27308",
      "card-properties-lib": "/card-properties-lib/static-1.42906",
      "crm-actions": "/crm-actions/static-1.5740",
      "crm-cards-data": "/crm-cards-data/static-1.736",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42268",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8239",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7534",
      "customer-data-tracking": "/customer-data-tracking/static-1.6439",
      "usage-tracker-container": "/usage-tracker-container/static-1.6906",
      "framework-data-table": "/framework-data-table/static-2.10868",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7897",
      "calling-error-reporting": "/calling-error-reporting/static-1.30857",
      "calling-internal-common": "/calling-internal-common/static-1.30851",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6119",
      "crm_data": "/crm_data/static-4.90498",
      "crm_schema": "/crm_schema/static-3.90537",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23337",
      "customer-data-content": "/customer-data-content/static-1.26401",
      "draft-content-plugins": "/draft-content-plugins/static-1.27259",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.23247",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22956",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23516",
      "FileManagerLib": "/FileManagerLib/static-1.37834",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16988",
      "integration-settings-components": "/integration-settings-components/static-1.14045",
      "integrations-lib": "/integrations-lib/static-1.14708",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5168",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7366",
      "nav-meta": "/nav-meta/static-1.28309",
      "onboarding-scopes": "/onboarding-scopes/static-1.6025",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5340",
      "property-translator": "/property-translator/static-1.4907",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.36487",
      "react-colorpicker": "/react-colorpicker/static-2.9764",
      "react-dnd-compat": "/react-dnd-compat/static-1.4206",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7748",
      "rich-text-lib": "/rich-text-lib/static-1.18990",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3428",
      "sequences-lib": "/sequences-lib/static-1.7335",
      "timezone-utils": "/timezone-utils/static-2.4732",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10581",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8481",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8489",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9803",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9632",
      "user-context": "/user-context/static-1.4669",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.4328",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4233",
      "salesImages": "/salesImages/static-1.515",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20522",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12602",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4211",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3563",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6351",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3255",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3487",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.547",
      "onboarding-tours": "/onboarding-tours/static-1.15959",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12329",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.177",
      "ui-addon-teams": "/ui-addon-teams/static-1.20927",
      "calling-global-api": "/calling-global-api/static-1.62963",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64345",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56639",
      "commerce-products-lib": "/commerce-products-lib/static-1.8139",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3428",
      "external-options-client-types": "/external-options-client-types/static-1.3647",
      "google-libphonenumber": "/google-libphonenumber/static-1.27",
      "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2754",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3735",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.117",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3265",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47250",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3488",
      "property-value-citations": "/property-value-citations/static-1.696",
      "smart-property-lib": "/smart-property-lib/static-1.5045",
      "tiered-pricing": "/tiered-pricing/static-1.481",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10540",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3638",
      "video-components-external": "/video-components-external/static-1.9917",
      "video-data-lib": "/video-data-lib/static-1.33575",
      "audio-components": "/audio-components/static-1.5326",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.35345",
      "video-components": "/video-components/static-1.11920",
      "video-embed": "/video-embed/static-1.34409",
      "batch-promise": "/batch-promise/static-1.1123",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3626",
      "persist-promise": "/persist-promise/static-1.3280",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.24076",
      "knowledge-content-types": "/knowledge-content-types/static-1.8170",
      "payment-link-components": "/payment-link-components/static-1.22360",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9435",
      "call-summary": "/call-summary/static-1.37654",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9058",
      "feature-store-service-types": "/feature-store-service-types/static-1.4126",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4133",
      "merchandise-lib": "/merchandise-lib/static-1.248",
      "purchase-motions-components": "/purchase-motions-components/static-1.5074",
      "self-service-api": "/self-service-api/static-1.9757",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4117",
      "chatspot-client-types": "/chatspot-client-types/static-1.10229",
      "chatspot-core": "/chatspot-core/static-1.19508",
      "ContentUtils": "/ContentUtils/static-1.66979",
      "copilot-toolkit": "/copilot-toolkit/static-1.9897",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6073",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44762",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14163",
      "customer-data-associations": "/customer-data-associations/static-1.6807",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.562",
      "reporting-data": "/reporting-data/static-1.65619",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4341",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3264",
      "crm_universal": "/crm_universal/static-1.21357",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8465",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19912",
      "content-embed-lib": "/content-embed-lib/static-1.6922",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10839",
      "remote-ui": "/remote-ui/static-1.55",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5148",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15868",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2569",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12123",
      "laboratory-lib": "/laboratory-lib/static-3.6676",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9965",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8399",
      "messaging-types-lib": "/messaging-types-lib/static-1.44671",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15662",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7192",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4563",
      "magpie-lib": "/magpie-lib/static-1.5146",
      "navigation-messaging": "/navigation-messaging/static-1.5999",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17258",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16376",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.7487",
      "growth-data-modal": "/growth-data-modal/static-1.4895",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2591",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.969",
      "navigation-components": "/navigation-components/static-1.16672",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4173",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.25",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7013",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10599",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34144",
      "products-iframe-lib": "/products-iframe-lib/static-1.6718",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9294",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4989",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8995",
      "fsm": "/fsm/static-1.3224",
      "policy-lib": "/policy-lib/static-1.6311",
      "react-tinymce": "/react-tinymce/static-1.53981",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.53107",
      "tinymce-plugins": "/tinymce-plugins/static-1.56221",
      "tinymce-themes": "/tinymce-themes/static-1.55077",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10403",
      "content-media-compositions": "/content-media-compositions/static-2.14410",
      "idb-keyval": "/idb-keyval/static-1.34",
      "magpie-types": "/magpie-types/static-1.4606",
      "media-bridge-lib": "/media-bridge-lib/static-1.18197",
      "content-icons-ui": "/content-icons-ui/static-1.2060",
      "social-insights-client-types": "/social-insights-client-types/static-1.20801",
      "outpost": "/outpost/static-1.3822",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
      "ui-addon-opt": "/ui-addon-opt/static-4.7978",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5354",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4672",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6916",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18823",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.7524",
      "wootric-nps": "/wootric-nps/static-1.6445",
      "nav-client-types": "/nav-client-types/static-1.1816",
      "purchase-motions-api": "/purchase-motions-api/static-1.5076",
      "trials-service-types": "/trials-service-types/static-1.3534",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4237",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2539",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35898",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38286",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17845",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10404",
      "crm_components": "/crm_components/static-3.90498",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53320",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20383",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16423",
      "project-storage": "/project-storage/static-1.4208",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70400",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7412",
      "deal-intel-utils": "/deal-intel-utils/static-1.566",
      "reporting-client-types": "/reporting-client-types/static-1.2304",
      "react-flip-move": "/react-flip-move/static-1.60",
      "FireAlarmUi": "/FireAlarmUi/static-1.4131",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3789",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10390",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.9015",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56595",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.11440",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.11375",
      "feedback-loader": "/feedback-loader/static-1.28367",
      "html-to-image": "/html-to-image/static-1.44",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6577",
      "property-management-iframe": "/property-management-iframe/static-1.11510",
      "reactflow": "/reactflow/static-1.51",
      "simple-data-table": "/simple-data-table/static-1.1524",
      "used-in-list-lib": "/used-in-list-lib/static-1.6432",
      "visual-association": "/visual-association/static-1.5362",
      "highcharts": "/highcharts/static-8.94",
      "reporting-visualizations": "/reporting-visualizations/static-1.57696",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3555",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2367",
      "ContentData": "/ContentData/static-1.67054",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.564",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1666",
      "reactive-lib": "/reactive-lib/static-1.273",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.110",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6300",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3592",
      "ui-tool-access": "/ui-tool-access/static-1.9666",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34369",
      "sales-views-client-types": "/sales-views-client-types/static-1.3823",
      "trellis-story-utils": "/trellis-story-utils/static-1.4064",
      "storybook-react": "/storybook-react/static-1.22",
      "hub-http-contrib": "/hub-http-contrib/static-1.2642",
      "interframe": "/interframe/static-3.4286",
      "tinymce-data": "/tinymce-data/static-1.39192",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4746",
      "codemirror": "/codemirror/static-5.85",
      "layout-dnd-components": "/layout-dnd-components/static-1.11616",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10591",
      "react-codemirror": "/react-codemirror/static-1.10186",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12900",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8710",
      "hls.js": "/hls.js/static-1.29",
      "js-cookie": "/js-cookie/static-1.18",
      "ai-rendering-library": "/ai-rendering-library/static-1.8630",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6980",
      "chirp-fetch": "/chirp-fetch/static-1.1478",
      "copilot-plugins": "/copilot-plugins/static-1.9870",
      "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2815",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17335",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35863",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9280",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4602",
      "utility-belt": "/utility-belt/static-1.2026",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21219",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.79118",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6270",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53336",
      "commerce-products-api": "/commerce-products-api/static-1.1544",
      "SafeStorage": "/SafeStorage/static-1.3880",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55394",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.101075",
      "reporting-ui-components": "/reporting-ui-components/static-2.62893",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14184",
      "association-translator": "/association-translator/static-1.2687",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7778",
      "settings-ui-nav": "/settings-ui-nav/static-2.9729",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19500",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1391",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5339",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3836",
      "property-management-common": "/property-management-common/static-1.3797",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.14433",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11448",
      "ExportDialog": "/ExportDialog/static-6.9975",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32770",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8916",
      "browser-eslint": "/browser-eslint/static-2.57",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12897",
      "highlight.js": "/highlight.js/static-1.69",
      "reporting-action-components": "/reporting-action-components/static-1.40100",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9124",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5061",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13667",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4569",
      "qrcode-generator": "/qrcode-generator/static-1.59",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.50",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16846",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6769",
      "products-ui-components": "/products-ui-components/static-1.38658",
      "totals-ui-components": "/totals-ui-components/static-1.22368",
      "reporting-plugins": "/reporting-plugins/static-1.9601",
      "reporting-reports": "/reporting-reports/static-1.65299",
      "reporting-snowflake": "/reporting-snowflake/static-1.54239",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14432",
      "simple-menus-lib": "/simple-menus-lib/static-1.15949",
      "academy-common-lib": "/academy-common-lib/static-1.12357",
      "dashboard-lib": "/dashboard-lib/static-1.79730",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8229",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9949",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15719",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18312",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7559",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "commerce-permissions": "/commerce-permissions/static-1.279",
      "property-description-translator": "/property-description-translator/static-1.3354",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3382",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7615",
      "academy-service-client": "/academy-service-client/static-1.3225",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3477",
      "oauth-service-types": "/oauth-service-types/static-1.3789",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};